
<p-confirmDialog header="Confirmation" appendTo="body"></p-confirmDialog>
<div class="col-lg-12 nopadding">
  <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="DefaultFilterArray"
    [ResetLabel]="isFilterLabelReset" (FilterEvent)="FilterApplyFilterEvent($event)"
    (FilterEventClearSymbol)="FilterEventClearSymbol($event)" (FilterEventClearCode)="FilterEventClearCode($event)">
  </app-filter-panel>
</div>

<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults) {
    <div class="example-loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  }
 <div class="card" (mouseup)="commonColService.stopDragging()" (mouseleave)="commonColService.stopDragging()">
  <p-contextMenu #cm [model]="commonColService.menuItems" appendTo="body" styleClass="column-context-menu"></p-contextMenu>
  <!--Grid Code  -->
  <p-table alwaysShowPaginator="true" paginatorPosition="both" showCurrentPageReport="true"
    [value]="dataset1" [class.table-frozen]="commonColService.isFrozenColumns" [columns]="commonColService.selectedColumns" [resizableColumns]="true" columnResizeMode="expand" [pageLinks]="15"
    [totalRecords]="totalRecords" [paginator]="true" [(selection)]="selectedRow" appendTo="body"
    [rows]="rowcount" (onPage)="changePage($event)"
    (onSort)="sort($event)" sortMode="multiple"
    [rowsPerPageOptions]="rowsPerPageOptions" [lazy]="true" 
    [pageLinks]="constantService.DEFAULT_PAGELINKS" #dt styleClass = "exception-table" [scrollable]="true" 
    [reorderableColumns]="true"
    (onColReorder)="commonColService.onColumnsReordered($event, dt)"
    scrollHeight="70vh">
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{tbldatamsg}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th id="clientDataExceptionTableCheckbox" style="width: 3em"pFrozenColumn
        [frozen]= "commonColService.hasFrozenColumns()">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        @for(col of columns; track col.field + '-'+ $index; let idx = $index) { 
          <th [attr.id]="'col-' + col.field"  pResizableColumn [pSortableColumn]="col.field" pFrozenColumn pReorderableColumn
          [frozen]="col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen" 
          alignFrozen="left"
          [style.left]="(col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
          [style.background-color]="col.frozen && !commonColService.selectedFields.includes(col.field) ? 'sortClass' : null"
          [class.selected-header]="commonColService.selectedFields.includes(col.field)"
          (mousedown)="commonColService.onHeaderMouseDown($event, col.field)"
          (mouseenter)="commonColService.onHeaderMouseEnter(col.field)"
          (contextmenu)="commonColService.onHeaderContextMenu($event, col.field,contextMenuItems, dt)"
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          <div class="header-cell-content">
          <span [class.excel-cursor-span]="(col.header | lowercase) !== 'action'"  style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            {{col.header}}
            @if((col.header | lowercase) !== 'action') {
              <p-sortIcon [field]="col.field"></p-sortIcon>
            }
            </span>
             @if(col.frozen) {
                          <i class="pi pi-lock" style="font-size: 0.85rem; color: #000; margin-left: 4px;"></i>
                      }
            </div>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      @if((row['modifiedFlag'] | lowercase) !== 'd') {
        <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex"
          [ngClass]="(row['modifiedFlag'] | lowercase)== 'u' ? 'ui-widget-updated-row' : (row['modifiedFlag'] | lowercase) == 'd' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row'">
          <td style="width: 3em;padding-left: 6px !important;" pFrozenColumn
                [frozen]= "commonColService.hasFrozenColumns()">
            <p-tableCheckbox [id]="'checkbox'+ rowIndex" [value]="row"></p-tableCheckbox>
          </td>
          @for(col of columns; track col.display + '-'+ $index; let idx = $index) {
            <td class="ui-resizable-column" pFrozenColumn
                [frozen]="col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen"
                alignFrozen="left"
                [style.left]="(col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
                [style.background-color]="selectedRow?.includes(row)? '#88c0eb': (col.frozen ? '#e2f0d9' : null)"   
                [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
              @if(col.header!=='action') {
                <span>
                <!-- set String -->
                 @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float') {
                   <span>
                    @if((col.header | lowercase) =='order id') {
                      <span>
                        <a [id]="'OrderID'+ rowIndex" (click)="onRowSelect('OrderID',rowIndex,row)" style="color: blue;cursor: pointer">{{row[col.field]}}</a>
                      </span>
                    }
                    @if((col.header | lowercase) !='order id') {
                      <span>
                        {{row[col.field]}}
                      </span>
                    }
                   </span>
                 }
      
                <!-- set int  -->
                 @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float') {
                   <span style="float:right;">
                     {{row[col.field] * 1}}
                   </span>
                 }
              </span>
              }
              @if(col.header==='action') {
                <span>
                  @if(commonColService.hasFrozenColumns()){
                  <p-button [style]="{'width': '20px'}" class="pi pi-xxx" or class="fa fa-xxx"
                      matTooltip="View" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye"
                      [id]="'view'+ rowIndex" (click)="onRowSelect('View',rowIndex,row)" [disabled]="selectedRow.length>=2"></p-button>}
                  @else{
                    @if(selectedRow.length < 2) {
                      <p-button [style]="{'width': '20px'}" class="pi pi-xxx" or class="fa fa-xxx"
                      matTooltip="View" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye"
                      [id]="'view'+ rowIndex" (click)="onRowSelect('View',rowIndex,row)"></p-button>
                    }
                  }
                    @if(row[col.field] != 'D') {
                      <p-button [id]="'edit'+ rowIndex" class="pi pi-xxx" or class="fa fa-xxx"
                       matTooltip="Edit" [matTooltipShowDelay]="1000"
                      matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-edit" (click)="onRowSelect('Edit',rowIndex,row);">
                      </p-button>
                    }
                    <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" [matTooltipShowDelay]="1000"
                    matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-trash"
                    [id]="'delete'+ rowIndex" (click)="onRowSelect('Delete',rowIndex,row)"></p-button>
                </span>
              }
            </td>
          }
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="paginatorright">
      @if((UserService.isRoleSuperUser() || UserService.isRoleFirmAdmin())) {
        <span class="mass-correction-wrapper" [class.mass-correction-disabled]="isMassCorrectionDisabled"
          [matTooltip]="massCorrectionTooltip"
          [matTooltipShowDelay]="isMassCorrectionDisabled ? 0 : 1000">
          <button class="exportBtn" [class.massCorrectionDisabled]="isMassCorrectionDisabled" [disabled]="isMassCorrectionDisabled"
            (click)="checkRecordTypes() && onShowMassCorrectionScreen()" type="button">Mass Correction
          </button>
        </span>
      }
        <app-export-to-csv [gridColumns]="GridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
      Total Records: {{dataset1.length == 0? 0 : totalRecords}}
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <!-- Page No : {{pageNumber }} -->
      Showing {{dataset1.length == 0? 0 : startLimit + 1}} to {{dataset1.length
            < rowcount ? dataset1.length < startLimit ? endLimit : dataset1.length : endLimit}} entries </ng-template>
  </p-table>
  </div>
  <br>
  <br>

</div>

<!--Edit Panel Code  -->
@if(Edit) {
  <p-dialog id="Edit" [(visible)]="Edit" header="" appendTo="body" height="auto" width="auto"
    [style]="{width: '78%', minWidth: '550px'}" [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
    maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [modal]="false" draggable="true">
    <div class="ui-grid-col-12 container">
      @for(row of selectedRow; track row.firmROEID + '-'+ $index; let idx = $index) { 
        <span *ngFor="let row of selectedRow;let i=index" backgroundColor="accent" class="zindex ">
          <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row">
            <div class="ui-g-12 ui-md-6 ui-lg-2 quick-view-grid-row">
              <strong> Failure Code : </strong>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row">
              <textarea disabled style="color:red; width:100%" required type="text" pInputText
                [(ngModel)]="errorcodesMap[row.firmROEID]">
                      </textarea>
            </div>
          </div>
          <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row">
            <div class="ui-g-12 ui-md-6 ui-lg-3 quick-view-grid-row">
              <strong> Failure Description : </strong>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row">
              <textarea disabled style="color:red; width:93%" required type="text" pInputText
                [(ngModel)]="exceptionsMap[row.firmROEID]">
                    </textarea>
            </div>
          </div>
    
          <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row">
            <div class="ui-g-12 ui-md-6 ui-lg-2 quick-view-grid-row">
              <strong> Actual Value : </strong>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row">
              <textarea disabled style="color:red; width:100%" required type="text" pInputText
                [(ngModel)]="row.actualValue">
            </textarea>
            </div>
          </div>
          <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row">
            <div class="ui-g-12 ui-md-6 ui-lg-3 quick-view-grid-row">
              <strong> Suggested Value : </strong>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row">
              <textarea disabled style="color:green; width:93%" required type="text" pInputText
                [(ngModel)]="row.suggestedValue">
          </textarea>
            </div>
          </div>
        </span>
      }
      @for(editRow of Editviewcols; track editRow.field_Name + '-'+ $index; let i = $index) { 
        <ng-container>
          <span
            [ngClass]="(editRow.field_Name| lowercase) !== 'buydetails' && (editRow.field_Name| lowercase) !== 'selldetails' && 
        (editRow.field_Name| lowercase) !== 'aggregatedorders'&& editRow.field_Name!=='firmDetails' && editRow.field_Name!=='handlingInstructions' &&
        (editRow.field_Name| lowercase) !== 'clientdetails'?'zindex ui-g-12 ui-md-12 ui-lg-4': 'zindex ui-g-12 ui-md-12 ui-lg-12'">
            @if(editRow) {
              <span>
                @if((editRow.field_Name| lowercase) !== 'buydetails' && (editRow.field_Name| lowercase) !== 'selldetails' && (editRow.field_Name| lowercase) !== 'aggregatedorders'
                && (editRow.field_Name| lowercase) !== 'clientdetails' &&  editRow.field_Name!=='firmDetails' && editRow.field_Name !== 'handlingInstructions') {
                  <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                    <div class="ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg">
                      <label for="ui_Field_Name">{{editRow.ui_Field_Name}}</label>
                    </div>
                    <div
                    [ngClass]="selectedRow!=null && selectedRow[0]?.firmROEID.length>0 && (exceptionsMap[selectedRow[0]?.firmROEID].toLowerCase().indexOf(' '+editRow?.field_Name.toLowerCase())>0) ? 'error ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row' :'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row'" [style.border]="editRow.isInvalid && editRow.errorMessage ? 'none' : null">
                    @if((editRow?.datatype | lowercase) == 'choice' || (editRow?.datatype | lowercase) == 'choicevalues') {
                      <ng-container>
                          <p-select  [name]="editRow.field_Name +'choice'" [id]="editRow.field_Name+'choice'"  [readonly]="editRow?.field_Name =='firmMPID'" [options]="editRow.dropdownvalue"
                            [(ngModel)]="editRow.value" appendTo="body" [style]="{'text-transform': 'capitalize','width':'100%'}"
                            placeholder="Select Value" filter="true" required="true" [showClear]="true">
                            <ng-template let-filterCols let-row pTemplate="item">
                              <div class="ui-helper-clearfix" style="text-transform:capitalize">
                                <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}</div>
                              </div>
                            </ng-template>
                          </p-select>
                        </ng-container>
                    } @else if ((editRow?.datatype | lowercase) =='int' || (editRow?.datatype | lowercase)=='float' || 
                    (editRow?.datatype | lowercase) =='number' || (editRow?.datatype | lowercase)=='bigdecimal') {
                          <ng-container>
                            <input type="number" ng-pattern="/^[0-9]$/" [name]="editRow.field_Name +'int'" [id]="editRow.field_Name+'int'" maxlength="10" required  placeholder="Enter Value" style="width:100%"
                              pInputText [(ngModel)]="editRow.value" [class.error]="editRow.isInvalid" (ngModelChange)="editRow.isInvalid = false" />
                          </ng-container>
                    } @else if((editRow?.datatype | lowercase)=='boolean') {
                          <ng-container>
                            <p-select [name]="editRow.field_Name +'boolean'" [id]="editRow.field_Name+'boolean'" [options]="BooleanDropDown" [(ngModel)]="editRow.value" appendTo="body"
                              [style]="{'text-transform': 'capitalize','width':'100%'}" placeholder="Select Value" filter="true"
                              required="true">
                              <ng-template let-filterCols let-row pTemplate="item">
                                <div class="ui-helper-clearfix" style="text-transform:capitalize">
                                  <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}</div>
                                </div>
                              </ng-template>
                            </p-select>
                          </ng-container> 
                    } @else if((editRow?.datatype | lowercase)=='string' || (editRow?.datatype | lowercase)=='char') {
                          <ng-container>
                            @if(editRow.field !='symbol' && editRow.field !='type') {
                              <input [title]="editRow.field_Name.indexOf('Date')>=0? format : ''" [name]="editRow.field_Name +'string'" [id]="editRow.field_Name+'string'" [disabled]="editRow.isDisable"
                                required type="text" placeholder="Enter Value" style="width:100%" pInputText
                                [(ngModel)]="editRow.value" [class.error]="editRow.isInvalid" (ngModelChange)="editRow.isInvalid = false"
                                [readonly]="editRow?.field_Name =='firmMPID'" />
                              }
                            @if(editRow.field =='symbol' || editRow.field =='type') {
                              <input [name]="editRow.field_Name +'string'" [id]="editRow.field_Name+'string'" [disabled]="editRow.isDisable"
                                [ngStyle]="{width:'100%'}" pInputText [id]="editRow.header" [(ngModel)]="editRow.value" [class.error]="editRow.isInvalid" (ngModelChange)="editRow.isInvalid = false" />
                            }  
                          </ng-container>
                    } @else if((editRow?.datatype | lowercase)=='date') {
                        <div>
                          <p-datepicker appendTo="body"
                          [touchUI]="true"
                          [(ngModel)]="editRow.value" 
                          [iconDisplay]="'input'"
                          [showIcon]="true" 
                          [readonlyInput]="false"
                          dateFormat="yy-mm-dd"
                          [hourFormat] = "'24'"
                          [style]="{'width':'95% !important'}"
                          [placeholder] = "'Enter Value'"
                          inputId="editRow.field_Name+'date'" (dateChange)="singleEditFormateDatetime(editRow.datatype,'date', i)"
                          [motionOptions]="{ duration: 0 }" />
                        </div>
                    } @else if((editRow?.datatype | lowercase)=='datetime' || (editRow?.datatype | lowercase)=='timestamp') {
                          <ng-container>
                            <div class="ui-g-12 nopadding ">
                              <input [name]="editRow.field_Name +'datetime'" [id]="editRow.field_Name+'datetime'" type="text" placeholder="Enter Value" style="width:100%" pInputText
                                [(ngModel)]="editRow.value" />
                            </div>
                          </ng-container>
                    }
                     <!-- <ng-template #ChoiceValues>
                        <ng-container *ngIf="(editRow?.datatype | lowercase)=='choicevalues'">
                          <div *ngIf="editRow.ui_Field_Name !== 'handlingInstructions'"
                            class="ui-g-12 ui-md-6 ui-lg-4 quick-view-grid-row">
                            <p-select [name]="editRow.field_Name +'choicevaluesDropdown'" [id]="editRow.field_Name+'choicevaluesDropdown'" [readonly]="editRow?.field_Name =='firmMPID'" [options]="editRow.dropdownvalue"
                              [(ngModel)]="newLabel" appendTo="body" (onChange)="setEditRowValue(i,newLabel)"
                              [placeholder]="getObjectKey(editRow.value)" filter="true" required="true">
                              <ng-template let-filterCols let-row let-rowIndex pTemplate="item">
                                <div class="ui-g-12 nopadding " style="text-transform:capitalize">
                                  <div [matTooltip]="filterCols.description" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}
                                  </div>
                                </div>
                              </ng-template>
                            </p-select>
                          </div>
                           <div *ngIf="editRow.ui_Field_Name !== 'handlingInstructions'"
                            class="ui-g-12 ui-md-6 ui-lg-8 quick-view-grid-row">
                            <input [name]="editRow.field_Name +'choicevalues'" [id]="editRow.field_Name+'choicevalues'" required type="text" placeholder="Enter Value" style="width:100%" pInputText
                              [(ngModel)]="editRow.value[getObjectKey(editRow.value)]" />
                          </div>
                          <div *ngIf="editRow.ui_Field_Name === 'handlingInstructions'">
                            <input [name]="editRow.field_Name +'choicevalues'" [id]="editRow.field_Name+'choicevalues'" required type="text" placeholder="Enter Value" style="width:100%" pInputText
                              [(ngModel)]="editRow.value" />
                          </div> 
                        </ng-container>
                      </ng-template>
                      -->
                    @if(editRow.isInvalid && editRow.errorMessage) {
                      <small class="field-error-message">{{editRow.errorMessage}}</small>
                    }
                    </div>
                  </div>
                }
                <!-- Nested Json Details -->
                 @if((editRow.field_Name| lowercase) === 'aggregatedorders') {
                   <div class="ui-grid-col-12 horizontal-scroll">
                     <mat-divider></mat-divider>
                     <span><b>Aggregated Order Details</b></span>
                     <p-table [columns]="aggoOrdersCols" [value]="editRow.value" #dt1>
                       <ng-template pTemplate="header" let-columns>
                         <tr>
                          @for(col of columns; track col.field + '-'+ $index; let idx = $index) { 
                            <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                              {{col.header}}
                            </th>
                          }
                         </tr>
                       </ng-template>
                       <ng-template pTemplate="body" let-aggoOrdersRowData let-ri="rowIndex" let-columns="columns">
                         <tr [pSelectableRow]="aggoOrdersRowData">
                          @for(col of columns; track col.field + '-'+ $index; let idx = $index) { 
                            <td [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                              @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float') {
                                <span>
                                  {{aggoOrdersRowData[col.field]}}
                                </span>
                              }
                              @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float') {
                                <span style="float:right;">
                                  {{aggoOrdersRowData[col.field]}}
                                </span>
                              }
                            </td>
                          }
                         </tr>
                       </ng-template>
                     </p-table>
                   </div>
  
                 }
                 @if(editRow.field_Name=='handlingInstructions') {
                   <div class="ui-grid-col-8 container">
                     <mat-divider></mat-divider>
                     <p-table [columns]="handlingInstructionCols" [value]="editRow.value" #dt2>
                       <ng-template pTemplate="caption">
                         <div class="row">
                             <div class="col-md-4" style="text-align:left">
                                 <span><b>Handling Instructions</b></span>
                               </div>
                               <div class="col-md-4" style="text-align:left">
                                 <p-multiSelect [name]="editRow.field_Name +'multiselect'" [id]="editRow.field_Name+'multiselect'" appendTo="body" [options]="this.UserService.handlingInstructions" [(ngModel)]="handlingInstructionCols" optionLabel="header"
                                  selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}"  placeholder="Choose Columns" class="client-data-exp-select"></p-multiSelect>
                             </div>
                         </div>     
                     </ng-template>
                       <ng-template pTemplate="header" let-columns>
                         <tr>
                          @for(col of columns; track col.header + '-'+ $index; let idx = $index) { 
                            <th id="colHeader">
                              {{col.header}}
                            </th>
                          }
                         </tr>
                       </ng-template>
                       <ng-template pTemplate="body" let-handlingInstructionData let-columns="columns">
                         <tr >
                          @for(col of columns; track col.field + '-'+ $index; let idx = $index) { 
                            <td style="width:10px" pEditableColumn>
                              <p-cellEditor>
                                <ng-template pTemplate="input">
                                  <input  [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'"  [(ngModel)]="handlingInstructionData[col.field]">
                                </ng-template>
                                <ng-template pTemplate="output">
                                  <span >
                                    {{handlingInstructionData[col.field]}}
                                  </span>
                                </ng-template>
                            </p-cellEditor>
                            
                            </td>
                          }
                         </tr>
                       </ng-template>
                     </p-table>
                   </div>
  
                 }
                 @if(editRow.field_Name=='buyDetails' || editRow.field_Name=='sellDetails' || editRow.field_Name=='clientDetails' || editRow.field_Name=='firmDetails') {
                   <div class="ui-grid-col-12 horizontal-scroll">
                     <mat-divider></mat-divider>
                     <span><b>{{editRow.field_Name === 'buyDetails' ? 'Buy Details': editRow.field_Name === 'sellDetails' ? 'Sell Details' : editRow.field_Name=='clientDetails' ? 'Client Details': editRow.field_Name=='firmDetails' ? 'Firm Details': ''}}</b></span>
                     <p-table [columns]="tradeSideDetailsCols" [value]="editRow.value" #dt2>
                       <ng-template pTemplate="header" let-columns>
                         <tr>
                          @for(col of columns; track col.header + '-'+ $index; let idx = $index) { 
                            <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                              {{col.header}}
                            </th>
                          }
                         </tr>
                       </ng-template>
                       <ng-template pTemplate="body" let-tradeSideRowData let-ri="rowIndex" let-columns="columns">
                         <tr [pSelectableRow]="tradeSideRowData">
                          @for(col of columns; track col.field + '-'+ $index; let idx = $index) { 
                            <td style="width:10px" pEditableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                              <p-cellEditor>
                                <ng-template pTemplate="input">
                                  @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float') {
                                    <input [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'" [(ngModel)]="tradeSideRowData[col.field]">
                                  }
                                  <!-- set int  -->
                                   @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float') {
                                     <input style="float:right;" [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'" [(ngModel)]="tradeSideRowData[col.field]">
                                    }
                                </ng-template>
                                <ng-template pTemplate="output">
                                  @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float') {
                                    <span>
                                      {{tradeSideRowData[col.field]}}
                                    </span>
                                  }
                                  <!-- set int  -->
                                   @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float') {
                                     <span style="float:right;">
                                       {{tradeSideRowData[col.field]}}
                                     </span>
                                   }
                                </ng-template>
                            </p-cellEditor>
                              <!-- set String -->
                            
                            </td>
                          }
                         </tr>
                       </ng-template>
                     </p-table>
                   </div>
                 }
              </span>
            }
          </span>
        </ng-container>
      }
  
    </div>
    <ng-template #footer>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">
        <button pButton type="button" icon="fa fa-close" [style]="{'background' : '#e54a23'}" id="catExceptionClose" (click)="Edit=false; isClickedOnce = false" label="Close">
        </button>
        <button pButton type="button" icon="fa fa-check" [disabled]="isClickedOnce" (click)="save()" id="catExceptionSave" label="Save"></button>
      </div>
    </ng-template>
  </p-dialog>
}

<!-- Quick View Panel Code  -->
<p-drawer styleClass="u ui-sidebar-lg"
  [style]="{'width':'auto','max-width': '500px','height':'auto','overflow-y': 'auto','max-height':'100%'}"
  [(visible)]="View" position="right" [baseZIndex]="10000">
  <div class="ui-grid ui-grid-responsive ui-fluid ">
    @for(ViewRow of Editviewcols; track ViewRow.ui_Field_Name + '-'+ $index; let idx = $index) { 
      <div class=" ui-grid-col-12">
        @if(ViewRow) {
          <div>
            <span>
              <div class="ui-grid-col-4 quick-view-grid-row">
                <label for="ui_Field_Name">{{ViewRow.ui_Field_Name}}</label>
              </div>
              <div lass="ui-grid-col-8 quick-view-grid-row">
                @if((ViewRow?.datatype | lowercase)!=='boolean') {
                  <input [disabled]="true" pInputText [(ngModel)]="ViewRow.value" style="width:65%" class="quick-side-bar-input"/>
                }
                @if((ViewRow?.datatype | lowercase)=='boolean') {
                  <input [disabled]="true" pInputText value="{{ViewRow.value === '1' || ViewRow.value === true ? 'True': 'False'}}" style="width:65%" class="quick-side-bar-input"> 
                }
              </div>
            </span>
          </div>
        }
      </div>
    }
  </div>
</p-drawer>

<!-- Mass correction Update -->
 @if(UserService.showMassCorrection) {
   <ng-container>
     <app-mass-correction 
       [totalRecords]="(this.selectedRow.length===0 ? totalRecords : selectedRow.length)" 
       [defaultFilters]="(this.selectedRow.length===0 ? DefaultFilterArray : filters)" 
       [massCorrectionColumns]="massCorrectionFields" 
       [hasComponentAPICall]="true"
       (updateMassCorrectionField)="updateMassCorrectedField($event)">
     </app-mass-correction>
   </ng-container>
 }